import { render, staticRenderFns } from "./history-detail.vue?vue&type=template&id=c73ba394&scoped=true&lang=pug&"
import script from "./history-detail.vue?vue&type=script&lang=js&"
export * from "./history-detail.vue?vue&type=script&lang=js&"
import style0 from "./history-detail.vue?vue&type=style&index=0&id=c73ba394&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73ba394",
  null
  
)

export default component.exports